<template>
  <div class="table_card">
    <div v-if="!printTickets">
      <div v-if="showAccessCreation">
        <div class="table_card__head">
          <v-flex lg10 class="table_card__head--sections">
            <p class="table_card__head--title">Registrar usuario</p>
          </v-flex>
          <v-flex lg2 class="filter_options table_card__head--sections">
            <div
              class="ticket_list__refresh_button faccess_button"
              @click="printTickets = !printTickets"
            >
              Imprimir Tickets
            </div>
          </v-flex>
          <v-flex
            lg2
            class="filter_options table_card__head--sections"
            v-show="aforo.location_name.includes('Feria')"
          >
            <div
              class="ticket_list__refresh_button faccess_button"
              @click="updateQrListDB()"
            >
              Actualizar Accesos
              <img
                src="@/assets/img/icons/refresh-icon-white.svg"
                class="ticket_list__refresh_button--icon"
              />
            </div>
          </v-flex>
        </div>
        <div class="table_card__body">
          <div>
            <v-layout row wrap>
              <v-flex xs12 row>
                <v-form
                  onSubmit="return false;"
                  ref="form"
                  v-model="validation"
                  lazy-validation
                >
                  <v-layout
                    row
                    wrap
                    style="background-color: #fff; padding: 0px"
                  >
                    <v-flex xs6 style="padding: 8px">
                      <v-text-field
                        label="Nombre:"
                        v-model="user.user_info_attributes.name"
                        :rules="letter_rules"
                        required
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6 style="padding: 8px">
                      <v-text-field
                        label="Apellido:"
                        v-model="user.user_info_attributes.last_name"
                        :rules="letter_rules"
                        required
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs6 style="padding: 24px 4px 0 8px">
                      <v-select
                        label="Tipo de Documento:"
                        :items="document_types"
                        v-model="user.user_info_attributes.document_type"
                        :rules="document_types_rules"
                        required
                      >
                      </v-select>
                    </v-flex>

                    <v-flex xs6 style="padding: 8px">
                      <v-text-field
                        label="Cédula:"
                        v-model="
                          user.user_info_attributes.identification_number
                        "
                        :rules="number_rules"
                        required
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs6 style="padding: 8px">
                      <v-text-field
                        label="Correo:"
                        v-model="user.user_info_attributes.email"
                        :rules="email_rules"
                        required
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs6 style="padding: 8px">
                      <v-text-field
                        label="Telefono:"
                        v-model="user.user_info_attributes.phone"
                        :rules="number_rules"
                        required
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs6 style="padding: 8px">
                      <v-select
                        label="Cantidad tickets:"
                        :rules="ticket_rules"
                        :items="tickects"
                        v-model="user.user_info_attributes.quantity"
                        required
                      >
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </div>
          <section class="modal_info" v-if="show_created_modal">
            <section
              class="modal_info__modal"
              style="height: fit-content; border-radius: 5px"
            >
              <div class="modal_info__modal__info">
                <!-- <img src="@/assets/icono-alerta.svg" width="80" height="80" style="margin-bottom: 30px;"> -->
                <h5>El Ticket fue creado con éxito</h5>
                <h5>¿Deseas imprimirlo?</h5>
              </div>
              <div class="modal_info__modal__buttons">
                <button
                  class="modal_info__modal__buttons--cancel"
                  @click="
                    show_created_modal = false;
                    clearForm();
                  "
                >
                  NO
                </button>
                <button
                  class="modal_info__modal__buttons--confirm"
                  @click="printTicket()"
                >
                  SI
                </button>
              </div>
            </section>
          </section>
        </div>
        <div class="table_card__footer">
          <button
            class="faccess_button"
            @click="createTicket()"
            :disabled="!validateForm"
          >
            Registrar usuario
          </button>
        </div>
      </div>
      <div v-else>
        <div class="table_card__head">
          <v-flex lg10 class="table_card__head--sections">
            <p class="table_card__head--title">Ips del counter</p>
          </v-flex>
          <v-flex lg2 class="filter_options table_card__head--sections">
            <div
              class="ticket_list__refresh_button faccess_button"
              @click="printTickets = !printTickets"
            >
              Imprimir Tickets
            </div>
          </v-flex>
        </div>
        <div class="table_card__body">
          <div>
            <v-layout row wrap>
              <v-flex xs12 row v-for="ip in counterIps" :key="ip">
                <h4>
                  {{ ip }}
                </h4>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>
    </div>
    <generate-qr
      v-else
      :visible="printTickets"
      @invisible="
        printTickets = !printTickets;
        searchingRut = '';
      "
      :documentNumber="searchingRut"
    />
  </div>
</template>

<script>
import GenerateQr from "@/components/views/bookingOffice/GenerateQr.vue";
export default {
  data() {
    return {
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      ticket: "",
      tickects: ["1", "2", "3", "4", "5"],
      document_types: ["CC", "TI", "CE"],
      ticket_rules: [
        value =>
          value == null ||
          (value && value.length >= 1) ||
          "Seleccione la cantidad de tickets"
      ],
      document_types_rules: [
        value =>
          value == null ||
          (value && value.length >= 1) ||
          "Seleccione un tipo de documento"
      ],
      letter_rules: [
        value => value == null || !!value || "Requerido.",
        value =>
          value == null ||
          (value && value.length >= 3) ||
          "Mínimo 3 caracteres",
        value =>
          value == null || /^([ña-zÑA-ZÀ-ÿ ])*$/.test(value) || "Solo letras"
      ],
      number_rules: [
        value => value == null || !!value || "Requerido.",
        value =>
          value == null ||
          (value && value.length >= 3) ||
          "Mínimo 3 caracteres",
        value => value == null || /^([0-9])*$/.test(value) || "Solo numeros"
      ],
      email_rules: [
        value => value == null || !!value || "Requerido.",
        value =>
          value == null ||
          (value && value.length >= 3) ||
          "Minimo 3 caracteres",
        value =>
          value == null ||
          /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(
            value
          ) ||
          "No identificamos el correo @example.com"
      ],
      geners: ["Femenino", "Masculino", "Otro"],
      show_created_modal: false,
      result: null,
      qr_string: null,
      user: {
        user_info_attributes: {
          name: "",
          last_name: "",
          membership_type: "",
          identification_number: "",
          email: "",
          birthday: "",
          quantity: ""
        }
      },
      rules: {
        required: value => !!value || "Required."
      },
      user_finded: false,
      validation: false,
      fs: null,
      path: null,
      dbPath: null,
      accessDB: "data.txt",
      authorizedDB: "authorized.txt",
      offlineDB: "offline.txt",
      encryptFile: "encrypt.txt",
      aforoFile: "aforo.json",
      socketPort: 1234,
      socketTimeout: 900,
      encryptSever: 100,
      getGrantedTimeout: 1000 * 60 * 60 * 1,
      testConnectionTimeout: 1000 * 60 * 2,
      maxByteSize: 1000,
      packageTime: 300,
      isOnLine: true,
      isEditing: false,
      maxTicketsNumber: null,
      showAccessCreation: false,
      counterIps: [],
      aforo: {
        current_capacity: 0,
        max_capacity: 10
      },
      validToken: true,
      printTickets: false,
      searchingRut: ""
    };
  },
  async created() {
    window.alert = function() {};
    alert = function() {};
    if (!window.eel) {
      this.isOnLine = navigator.onLine;
      await this.addFileMethods();
      await this.updateQrListDB();
      this.findIpDevices();
    } else {
      let res = await eel.eel_get_local_ip()();
      this.counterIps = res;
    }
  },
  watch: {
    result() {
      console.log(this.result);
    }
  },
  computed: {
    validateForm() {
      if (
        this.user.user_info_attributes.name != "" &&
        this.user.user_info_attributes.last_name != "" &&
        this.user.user_info_attributes.email != "" &&
        this.user.user_info_attributes.identification_number != "" &&
        this.user.user_info_attributes.phone != "" &&
        this.user.user_info_attributes.document_type != "" &&
        this.user.user_info_attributes.quantity != ""
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    async addFileMethods() {
      try {
        this.fs = window.require("fs");
        this.path = window.require("path");
        this.dbPath = this.path.join(
          this.path.resolve(window.__dirname + "/../.."),
          "db"
        );
        if (!this.fs.existsSync(this.dbPath)) {
          await this.fs.mkdirSync(this.dbPath);
        }
        if (!this.fs.existsSync(this.path.join(this.dbPath, this.accessDB))) {
          //if file not exists
          await this.fs.readFileSync(
            this.path.join(this.dbPath, this.accessDB),
            { encoding: "utf-8", flag: "w+" }
          );
        }
        if (
          !this.fs.existsSync(this.path.join(this.dbPath, this.authorizedDB))
        ) {
          //if file not exists
          await this.fs.readFileSync(
            this.path.join(this.dbPath, this.authorizedDB),
            { encoding: "utf-8", flag: "w+" }
          );
        }
        if (!this.fs.existsSync(this.path.join(this.dbPath, this.offlineDB))) {
          //if file not exists
          await this.fs.readFileSync(
            this.path.join(this.dbPath, this.offlineDB),
            { encoding: "utf-8", flag: "w+" }
          );
        }
        if (
          !this.fs.existsSync(this.path.join(this.dbPath, this.encryptFile))
        ) {
          //if file not exists
          await this.fs.readFileSync(
            this.path.join(this.dbPath, this.encryptFile),
            { encoding: "utf-8", flag: "w+" }
          );
        }
        if (!this.fs.existsSync(this.path.join(this.dbPath, this.aforoFile))) {
          //if file not exists
          await this.fs.writeFileSync(
            this.path.join(this.dbPath, this.aforoFile),
            JSON.stringify(this.aforo)
          );
        } else {
          let aforo = await this.fs.readFileSync(
            this.path.join(this.dbPath, this.aforoFile),
            "utf-8"
          );
          this.aforo = JSON.parse(aforo);
        }
        let lastLog = await this.fs.readFileSync(
          this.path.join(this.dbPath, "lastLog.txt"),
          "utf-8"
        );
        this.maxTicketsNumber = parseInt(lastLog.split("\n")[2].split(",")[0]);
        this.showAccessCreation =
          parseInt(lastLog.split("\n")[2].split(",")[1]) != 0;
        if (!this.showAccessCreation) {
          let os = window.require("os");
          let networkInterfaces = os.networkInterfaces();
          this.counterIps = Object.values(networkInterfaces).reduce(
            (ips, net) => {
              let newIps = ips;
              net.map(ip => {
                if (ip.family == "IPv4" && ip.address != "127.0.0.1") {
                  newIps.push(ip.address);
                }
              });
              return newIps;
            },
            []
          );
        }
        if (this.maxTicketsNumber) {
          this.tickects = [...Array(this.maxTicketsNumber).keys()].map(
            (_, i) => `${i + 1}`
          );
        }
      } catch (e) {
        this.updateAlertMessage(
          "Ingrese al counter desde un aplicativo de escritorio"
        );
        this.updateIsInAlert(true);
      }
    },
    async writeQrListDB(text) {
      await this.fs.writeFileSync(
        this.path.join(this.dbPath, this.accessDB),
        text
      );
    },
    async writeAuthListDB(text) {
      await this.fs.writeFileSync(
        this.path.join(this.dbPath, this.authorizedDB),
        text
      );
    },
    async writeOfflineListDB(text) {
      await this.fs.writeFileSync(
        this.path.join(this.dbPath, this.offlineDB),
        text
      );
    },
    async writeEncryptFile(text) {
      await this.fs.writeFileSync(
        this.path.join(this.dbPath, this.encryptFile),
        text
      );
    },
    async readQrListDB() {
      let qrsText = await this.fs.readFileSync(
        this.path.join(this.dbPath, this.accessDB),
        "utf-8"
      );
      return qrsText.split("\n");
    },
    async readAuthListDB() {
      let qrsText = await this.fs.readFileSync(
        this.path.join(this.dbPath, this.authorizedDB),
        "utf-8"
      );
      return qrsText ? qrsText.split("\n") : [];
    },
    async readOfflineListDB() {
      let qrsText = await this.fs.readFileSync(
        this.path.join(this.dbPath, this.offlineDB),
        "utf-8"
      );
      return qrsText ? qrsText.split("\n") : [];
    },
    async readEncryptFile() {
      let toEncrypt = await this.fs.readFileSync(
        this.path.join(this.dbPath, this.encryptFile),
        "utf-8"
      );
      return toEncrypt ? toEncrypt.split("\n") : [];
    },
    async removeQrDB(text) {
      let qrsList = await this.readQrListDB();
      let newQr = "";
      let existQr = false;
      let qrToDelete = text
        .split(".")
        .slice(0, 4)
        .join(".");
      let newQrsList = qrsList.reduce((qrsList, qr) => {
        let delQr = qr.split(".");
        if (!existQr && qr != "" && qrToDelete == delQr.slice(0, 4).join(".")) {
          existQr = true;
          let numberUses = parseInt(delQr[4]) + 1;
          newQr = qrToDelete + "." + numberUses;
          if (numberUses < parseInt(delQr[3])) {
            qrsList.push(newQr);
          }
        } else {
          qrsList.push(qr);
        }
        return qrsList;
      }, []);
      if (existQr) {
        await this.writeQrListDB(newQrsList.join("\n"));
        await this.removeOfflineListDB(qrToDelete);
        return newQr;
      }
    },
    async removeOfflineListDB(text) {
      let offlineDB = await this.readOfflineListDB();
      offlineDB = offlineDB.reduce((ticketList, ticket) => {
        ticket = JSON.parse(ticket);
        if (
          ticket.qr
            .split(".")
            .slice(0, 4)
            .join(".") == text
        ) {
          ticket.uses--;
          if (ticket.uses > 0) {
            ticketList.push(JSON.stringify(ticket));
          }
        } else {
          ticketList.push(JSON.stringify(ticket));
        }
        return ticketList;
      }, []);
      if (offlineDB.length > 0) {
        await this.writeOfflineListDB(offlineDB.join("\n"));
      } else {
        await this.writeOfflineListDB("");
      }
    },
    async searchAccessKeyDB(text) {
      let qrsList = await this.readQrListDB();
      let existQr = false;
      qrsList.map(qr => {
        existQr = existQr || text == qr.split(".")[0];
      });
      return existQr;
    },
    async searchAccessPinDB(text) {
      let qrsList = await this.readQrListDB();
      let existPin = false;
      qrsList.map(qr => {
        if (!existPin) {
          existPin = text == qr.split(".")[1] ? qr.split(".")[0] : false;
        }
      });
      return existPin;
    },
    async searchAccessNFCDeviceDB(text) {
      let qrsList = await this.readQrListDB();
      let existDevice = false;
      qrsList.map(qr => {
        if (!existDevice) {
          existDevice =
            qr.split(".")[0] == "6" && text == qr.split(".")[2]
              ? qr.split(".")[1]
              : false;
        }
      });
      return existDevice;
    },
    async addQrDB(text) {
      let qrsList = await this.readQrListDB();
      if (qrsList.length == 1 && qrsList[0] == "") {
        qrsList[0] = text;
      } else {
        qrsList.push(text);
      }
      await this.writeQrListDB(qrsList.sort().join("\n"));
    },
    async addAuthDB(text) {
      let qrsList = await this.readAuthListDB();
      if (
        qrsList.length == 1 &&
        (qrsList[0] == "" || qrsList[0] == " " || qrsList[0] == "\n")
      ) {
        qrsList[0] = text;
      } else {
        qrsList.push(text);
      }
      await this.writeAuthListDB(qrsList.join("\n"));
    },
    async addOfflineDB(text) {
      let qrsList = await this.readOfflineListDB();
      if (
        qrsList.length == 1 &&
        (qrsList[0] == "" || qrsList[0] == " " || qrsList[0] == "\n")
      ) {
        qrsList[0] = text;
      } else {
        qrsList.push(text);
      }
      await this.writeOfflineListDB(qrsList.join("\n"));
    },
    async updateQrListDB() {
      if (this.validToken) {
        let ticketsOffline = await this.readOfflineListDB();
        ticketsOffline = ticketsOffline.map(ticket => {
          if (ticket != "" && ticket != " " && ticket != "{}") {
            ticket = JSON.parse(ticket);
            if (!ticket.user_id) {
              ticket.user_id = this.getUserId();
            }
          }
          return ticket;
        });
        this.$http
          .post(
            "app/bookings/create_ticket",
            {
              data: this.encrypt({
                tickets: ticketsOffline ? ticketsOffline : []
              }).toString()
            },
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken()
              }
            }
          )
          .then(async function(response) {
            // await this.writeOfflineListDB("");
            let in_out = await this.readAuthListDB();
            this.$http
              .post(
                "access/update_scan_actions",
                {
                  data: this.encrypt({
                    bookingOffice_id: this.getUserId(),
                    in_out
                  }).toString()
                },
                {
                  headers: {
                    "X-Device-ID": this.getDeviceId(),
                    Authorization: "Bearer " + this.getUserToken()
                  }
                }
              )
              .then(async function(response) {
                this.isOnLine = true;
                await this.writeAuthListDB("");
                this.$http
                  .get("access/get_granted_users_pi", {
                    headers: {
                      "X-Device-ID": this.getDeviceId(),
                      Authorization: "Bearer " + this.getUserToken()
                    },
                    params: {
                      bookingOffice_id: this.getUserId()
                    }
                  })
                  .then(async function(response) {
                    await this.writeQrListDB(
                      response.body.data.sort().join("\n")
                    );
                    let offlineDB = await this.readOfflineListDB();
                    await this.writeOfflineListDB("");
                    for (let i = 0; i < offlineDB.length; i++) {
                      let ticket = offlineDB[i];
                      ticket = JSON.parse(ticket);
                      let tiempos = ticket.end_time
                        .split("GTM")[0]
                        .replace(/-/g, " ")
                        .replace(/:/g, " ")
                        .split(" ");
                      let end = new Date(
                        Date.UTC(
                          tiempos[0],
                          parseInt(tiempos[1]) - 1,
                          tiempos[2],
                          tiempos[3],
                          tiempos[4]
                        )
                      );
                      end.setHours(
                        end.getHours() -
                          parseInt(ticket.end_time.split("GMT")[1])
                      );
                      if (end > new Date()) {
                        await this.createTicketOffline(ticket, true);
                      }
                    }
                    for (let i = 0; i < response.body.tickets.length; i++) {
                      let ticket = response.body.tickets[i];
                      let tiempos = ticket.end_time
                        .split("GTM")[0]
                        .replace(/-/g, " ")
                        .replace(/:/g, " ")
                        .split(" ");
                      let end = new Date(
                        Date.UTC(
                          tiempos[0],
                          parseInt(tiempos[1]) - 1,
                          tiempos[2],
                          tiempos[3],
                          tiempos[4]
                        )
                      );
                      end.setHours(
                        end.getHours() -
                          parseInt(ticket.end_time.split("GMT")[1])
                      );
                      if (end > new Date()) {
                        await this.createTicketOffline(ticket, true);
                      }
                    }
                  })
                  .catch(e => {
                    if (e.status == 0) {
                      this.isOnLine = false;
                      this.updateNameUser("Offline Counter");
                      this.isEditing = false;
                    }
                    console.log("Counter-server error conection", e);
                  });
              })
              .catch(e => {
                if (e.status == 0) {
                  this.isOnLine = false;
                  this.updateNameUser("Offline Counter");
                  this.isEditing = false;
                } else {
                  this.isOnLine = true;
                }
                console.log("Counter-server error conection", e);
              });
          })
          .catch(e => {
            if (e.status == 0) {
              this.isOnLine = false;
              this.updateNameUser("Offline Counter");
              this.isEditing = false;
            } else {
              this.isOnLine = true;
            }
            console.log("Counter-server error conection", e);
          });
        let tickets = await this.readQrListDB();
        let auth = await this.readAuthListDB();
        return [tickets.length, auth.length];
      }
    },
    async reconect() {
      this.validToken = false;
      let lastLog = await this.fs.readFileSync(
        this.path.join(this.dbPath, "lastLog.txt"),
        "utf-8"
      );
      this.$http
        .post(
          "users/sign_in",
          {
            data: lastLog.split("\n")[0]
          },
          {
            headers: {
              "X-Device-ID": this.getDeviceId()
            }
          }
        )
        .then(async function(response) {
          if (
            response.body.meta.authentication_token != undefined &&
            response.body.meta.authentication_token != null &&
            response.body.meta.authentication_token != ""
          ) {
            if (
              response.body.meta.uuid != undefined &&
              response.body.meta.uuid != null
            ) {
              this.updateUserIdEncrypt(response.body.meta.uuid);
            }
            this.updateUserRoles(response.body.data.attributes.user_roles);
            if (
              response.body.data.attributes.user_info_type == "booking_office"
            ) {
              this.updateUserToken(response.body.meta.authentication_token);
              this.updateUserId(response.body.data.id);
              this.updateNameUser("");
              this.updateEmailUser(response.body.data.attributes.email);
              this.updateUserType("Booking_office");
              this.validToken = true;
              this.$router.push({ name: "booking_office" });
            }
          }
        });
    },
    configScaners() {
      if (
        !this.getScanDevicesSockets() ||
        !this.getScanDevicesSockets().guardian
      ) {
        let sockets = [];
        this.getScanDevicesIps().map(([ip, id]) => {
          if (ip) {
            let wsIp = `ws://${ip}:${this.socketPort}/`;
            try {
              let socket = new WebSocket(wsIp);
              socket.onerror = this.socketDevOnError;
              socket.onopen = this.socketDevOnConnect;
              socket.onmessage = this.socketDevOnMessage;
              socket.onclose = this.socketDevOnMessage;
              sockets.push({ wsIp, socket, id, inSend: false });
            } catch (error) {}
          }
        });
        let guardian = setInterval(() => {
          let {
            context,
            guardian,
            serverUpdater,
            sockets
          } = this.getScanDevicesSockets();
          // console.log("Guardian sockets", sockets);
          sockets = sockets.map(({ wsIp, socket, id, inSend }) => {
            let newSocket;
            if (socket.readyState == 2 || !context.getIsLogin()) {
              socket.close();
              newSocket = socket;
            } else if (socket.readyState == 3) {
              socket.close();
              try {
                newSocket = new WebSocket(wsIp);
                newSocket.onopen = socket.onopen;
                newSocket.onmessage = socket.onmessage;
                newSocket.onclose = socket.onclose;
                newSocket.onerror = socket.onerror;
                inSend = false;
              } catch (e) {
                newSocket = socket;
              }
            } else {
              newSocket = socket;
              if (!inSend) {
                try {
                  socket.send(
                    `${JSON.stringify({
                      type: "Test connection",
                      status: "1"
                    })}`
                  );
                } catch (error) {}
              }
            }
            return { wsIp, socket: newSocket, id, inSend };
          });
          if (!context.getIsLogin()) {
            clearInterval(serverUpdater.getGranted);
            clearInterval(serverUpdater.testConnection);
            clearInterval(serverUpdater.encryptData);
            clearInterval(guardian);
            context.updateScanDevicesSockets({});
          } else {
            this.updateScanDevicesSockets({
              context,
              guardian,
              serverUpdater,
              sockets
            });
          }
        }, this.socketTimeout);
        let serverUpdater = {
          getGranted: setInterval(async () => {
            let { context, sockets } = this.getScanDevicesSockets();
            this.reconect();
            setTimeout(async () => {
              let ticketsSize = await context.updateQrListDB();
              sockets.map(({ socket }) => {
                if (socket.readyState == 1) {
                  let date = new Date();
                  let secretQuery = `fu${date.getUTCFullYear()}se${date.getUTCMonth()}pong${date.getUTCDate()}`;
                  socket.send(
                    `${JSON.stringify({
                      type: "updateDevice",
                      status: "1",
                      size: ticketsSize
                    })}////\n${secretQuery}`
                  );
                }
              });
            }, 1000);
          }, this.getGrantedTimeout),
          testConnection: setInterval(async () => {
            let { context } = this.getScanDevicesSockets();
            context.findIpDevices();
          }, this.testConnectionTimeout),
          encryptData: setInterval(async () => {
            let { context } = this.getScanDevicesSockets();
            await context.encryptDataFile();
          }, this.encryptSever)
        };
        this.updateScanDevicesSockets({
          context: this,
          guardian,
          serverUpdater,
          sockets
        });
      }
    },
    async encryptDataFile() {
      let toEncrypt = await this.readEncryptFile();
      let encrypted = "";
      if (toEncrypt[0] == "0") {
        try {
          let payload = JSON.parse(toEncrypt[2]);
          let access = await this.fs.readFileSync(
            this.path.join(this.dbPath, "lastLog.txt"),
            "utf-8"
          );
          let token = access.split("\n")[0];
          if (toEncrypt[1] == "encryptLogin") {
            let text = this.encrypt(payload).toString();
            encrypted = text == token ? text : "0";
          } else if (toEncrypt[1] == "createAccess") {
            if (payload.auth != token) {
              encrypted = "0";
            } else {
              let offlineResponse = await this.createTicketOffline(
                payload.ticket,
                false
              );
              if (offlineResponse == "created") {
                encrypted = "Información recibida y procesada correctamente";
              } else if (offlineResponse == "reff_reppited") {
                encrypted = "-2";
              } else {
                encrypted = "-1";
              }
            }
          } else if (toEncrypt[1] == "searchTickets") {
            if (payload.auth != token) {
              encrypted = "0";
            } else {
              let qrs = await this.readQrListDB();
              let encryRut = this.encrypt(payload.identification_number);
              encrypted = qrs
                .filter(qr => {
                  let [, , qrEncryRut] = qr.split(".");
                  return qrEncryRut == encryRut;
                })
                .map((qr, i) => {
                  let [qrType, , qrEncryRut, qrConsecutive] = qr.split(".");
                  let time_send = new Date().getTime();
                  return (
                    "<" +
                    qrType.toString() +
                    "." +
                    this.encrypt(this.getUserId()) +
                    "." +
                    qrEncryRut +
                    "." +
                    qrConsecutive.toString() +
                    "." +
                    time_send +
                    ">"
                  );
                });
              encrypted = encrypted.join(";");
              if (encrypted == "" || encrypted == " ") {
                encrypted = "-1";
              }
            }
          }
        } catch (e) {
          encrypted = "0";
        }
      }
      if (encrypted != "") {
        let text = "1" + "\n" + toEncrypt[1] + "\n" + encrypted;
        await this.writeEncryptFile(text);
      }
    },
    async postData(url = "", data = {}) {
      try {
        var formData = new FormData();
        Object.entries(data).map(couple => {
          formData.append(couple[0], JSON.stringify(couple[1]));
        });
        const response = await fetch(url, {
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          body: formData // body data type must match "Content-Type" header
        });
        let resposeData = await response.json();
        console.log(resposeData);
      } catch (e) {
        console.log(e);
      }
    },
    async getData(url = "") {
      let response;
      try {
        response = await fetch(url);
        let resposeData = await response.json();
        console.log(resposeData);
      } catch (e) {
        console.log(e);
      }
    },
    findAccess() {
      // this.getData("https://192.168.0.17/api/set_in_out_activity.php");
    },
    async createTicket() {
      let full_name =
        this.user.user_info_attributes.name +
        " " +
        this.user.user_info_attributes.last_name;
      let ref_number = `FP.US:${this.getUserId()}.TM:${new Date().getTime()}`;
      let hoy = new Date();
      let mañana = new Date();
      mañana.setDate(hoy.getDate() + 1);
      let ticket = {
        full_name,
        email: this.user.user_info_attributes.email,
        identification_number: this.user.user_info_attributes
          .identification_number,
        phone_number: this.user.user_info_attributes.phone,
        document_type: this.user.user_info_attributes.document_type,
        user_id: this.getUserId(),
        quantity: this.user.user_info_attributes.quantity,
        voucher_state: "creado",
        voucher_type: "venta",
        associate: "",
        start_time: this.createTicketsDates(hoy),
        end_time: this.createTicketsDates(mañana),
        ref_number
      };
      let offlineResponse = await this.createTicketOffline(ticket, false);
      if (offlineResponse == "created") {
        this.show_created_modal = true;
        if (this.isOnLine) {
          this.$http
            .post(
              "app/bookings/create_ticket",
              {
                data: this.encrypt({
                  tickets: [ticket],
                  send_email: true
                }).toString()
              },
              {
                headers: {
                  "X-Device-ID": this.getDeviceId(),
                  Authorization: "Bearer " + this.getUserToken()
                }
              }
            )
            .catch(e => {
              if (e.status == 0) {
                this.isOnLine = false;
                this.updateNameUser("Offline Counter");
                this.isEditing = false;
              } else {
                this.updateAlertMessage(e.ans);
                this.updateIsInAlert(true);
              }
            });
        }
      } else if (offlineResponse == "complete") {
        this.updateAlertMessage(
          `El cliente ya ha comprado la cantidad máxima de tickets (${
            this.maxTicketsNumber
          })`
        );
        this.updateIsInAlert(true);
      } else if (offlineResponse == "max") {
        this.updateIsInAlert(true);
      }
    },
    async createTicketOffline(data, updateDB = true) {
      if (!data.full_name) {
        data.full_name = data.name + " " + data.last_name;
      }
      if (!data.uses) {
        data.uses = data.quantity;
      }
      let qrs = [];
      let qr_type = 3;
      let qrsCreated = await this.readQrListDB();
      let encryRut = this.encrypt(data.identification_number);
      let createdtickets = qrsCreated.reduce((usesCount, qr) => {
        let [, , qrEncryRut, uses] = qr.split(".");
        if (qrEncryRut == encryRut) {
          usesCount += parseInt(uses);
        }
        return usesCount;
      }, 0);
      let ticketsOffline = await this.readOfflineListDB();
      let ref_reppited = false;
      ticketsOffline.map(ticket => {
        if (ticket != "" && ticket != " " && ticket != "{}" && !ref_reppited) {
          ticket = JSON.parse(ticket);
          if (ticket.ref_number && ticket.ref_number == data.ref_number) {
            ref_reppited = true;
          }
        }
        return ticket;
      });
      if (ref_reppited) {
        return "reff_reppited";
      } else if (
        !this.maxTicketsNumber ||
        this.maxTicketsNumber >= parseInt(data.uses) + createdtickets
      ) {
        for (let i = 0; i < data.uses; i++) {
          let temp_qr =
            qr_type.toString() +
            "." +
            this.encrypt(this.getUserId()) +
            "." +
            encryRut +
            "." +
            1 +
            ".0";
          qrs.push(temp_qr);
        }
        let jsonToSend = data;
        jsonToSend.qr = qrs[0];
        await this.addQrDB(qrs.join("\n"));
        await this.addOfflineDB(JSON.stringify(jsonToSend));
        if (!updateDB) {
          this.socketNewTickets(qrs.join("\n"));
        }
        return "created";
      } else if (this.maxTicketsNumber <= createdtickets) {
        return "complete";
      } else {
        this.updateAlertMessage(
          `El cliente ya ha comprado ${createdtickets} de un total máximo permitido de ${
            this.maxTicketsNumber
          } tickets`
        );
        return "max";
      }
    },
    constructQrTickets() {
      let qr_type = 3;
      let count = 1;
      let time_send = new Date().getTime();
      this.qr_string =
        "<" +
        qr_type.toString() +
        "." +
        this.encrypt(this.getUserId()) +
        "." +
        this.encrypt(this.user.user_info_attributes.identification_number) +
        "." +
        count.toString() +
        "." +
        time_send +
        ">";
      console.log(this.qr_string);
    },
    printTicket() {
      this.printTickets = !this.printTickets;
      this.searchingRut = `${
        this.user.user_info_attributes.identification_number
      }`.trim();
      this.show_created_modal = false;
      this.clearForm();
    },
    clearForm() {
      this.user = {
        user_info_attributes: {
          name: null,
          last_name: null,
          identification_number: null,
          email: null,
          document_type: null,
          phone: null,
          quantity: null
        }
      };
    },
    findIpDevices() {
      if (this.validToken) {
        let oldIsOnLine = this.isOnLine;
        this.$http
          .get("app/scan_devices/find_ip_devices", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params: {
              id: this.getUserId()
            }
          })
          .then(async function(response) {
            this.isOnLine = true;
            if (oldIsOnLine == false) {
              this.reconect();
            } else if (
              response.body.data.scanners.length > 0 &&
              this.getScanDevicesIps() != response.body.data.scanners
            ) {
              let aforo = await this.fs.readFileSync(
                this.path.join(this.dbPath, this.aforoFile),
                "utf-8"
              );
              this.aforo = JSON.parse(aforo);
              let location = response.body.data.location;
              let day = response.body.data.day;
              this.aforo.location_name = location.name;
              if (location.name.includes("Feria")) {
                this.getGrantedTimeout = 1000 * 60 * 10;
              }
              this.aforo.max_capacity = response.body.data.max_capacity;
              this.aforo.ocupacion = parseInt(
                100 * (this.aforo.current_capacity / this.aforo.max_capacity)
              );
              if (
                day != this.aforo.day ||
                location.id != this.aforo.location_id
              ) {
                let company = this.getCompany();
                this.aforo.company_name = company.company_name;
                this.aforo.location_id = location.id;
                this.aforo.day = day;
                this.aforo.current_capacity = 0;
                this.aforo.ocupacion = parseInt(
                  100 * (this.aforo.current_capacity / this.aforo.max_capacity)
                );
                this.aforo.img = company.personalize.app_logo.thumb.url;
                this.aforo.color1 = company.personalize.colors.principal;
                this.aforo.color2 = company.personalize.colors.secundary;
              }
              await this.fs.writeFileSync(
                this.path.join(this.dbPath, this.aforoFile),
                JSON.stringify(this.aforo)
              );
              this.updateScanDevicesIps(response.body.data.scanners);
              this.configScaners();
            } else {
              this.updateAlertMessage(
                "No se encontraron dispositivos asociados a esta locacion"
              );
              this.updateIsInAlert(true);
            }
          })
          .catch(async e => {
            if (e.status == 0) {
              this.isOnLine = false;
              this.updateNameUser("Offline Counter");
              this.isEditing = false;
              let lastLog = await this.fs.readFileSync(
                this.path.join(this.dbPath, "lastLog.txt"),
                "utf-8"
              );
              let scaners = lastLog
                .split("\n")[3]
                .split(";")
                .map(couple => {
                  return couple.split(",");
                });
              this.updateScanDevicesIps(scaners);
              this.configScaners();
            } else if (oldIsOnLine == false) {
              this.reconect();
            }
          });
      }
    },
    async socketDevOnMessage(event) {
      if (event.data) {
        let edit = this.isEditing;
        while (edit) {
          await new Promise(resolve => setTimeout(resolve, 100));
          edit = this.isEditing;
        }
        this.isEditing = true;
        let [headers, body] = event.data.split("////\n");
        headers = JSON.parse(headers);
        if (headers.type == "update") {
          let date = new Date();
          let secretQuery = `fu${date.getUTCFullYear()}se${date.getUTCMonth()}pong${date.getUTCDate()}`;
          let tickets = await this.readQrListDB();
          let auth = await this.readAuthListDB();
          event.target.send(
            `${JSON.stringify({
              type: "updateDevice",
              status: "1",
              size: [tickets.length, auth.length]
            })}////\n${secretQuery}`
          );
        } else {
          if (body != "" && body != "\n") {
            if (headers.type == "delTickets") {
              await this.socketAuthorizedTickets(event.target.url, body);
            } else if (headers.type == "authTicket") {
              await this.socketAuthPetition(
                event.target.url,
                body,
                headers.time
              );
            } else if (headers.type == "buttonExit") {
              await this.socketAccessExit(event.target.url, body, headers.time);
            }
          }
          if (headers.status == "1") {
            event.target.send(
              `${JSON.stringify({ type: "recived", status: "1" })}`
            );
          }
        }
        this.isEditing = false;
      }
    },
    socketDevOnConnect(event) {
      console.log("new connection from ", event);
    },
    socketDevOnDisconect(event) {
      event.target.close();
      console.log("Desconection from:", event.target);
    },
    socketDevOnError(event) {
      event.stopImmediatePropagation();
      event.preventDefault();
      event.target.close();
      console.log("Desconection from:", event.target);
    },
    async socketAccessExit(wsIpEmisor, dato, time) {
      if (dato && dato != "\n" && dato != "") {
        if (this.aforo.current_capacity > 0) {
          this.aforo.current_capacity--;
          this.aforo.ocupacion = parseInt(
            100 * (this.aforo.current_capacity / this.aforo.max_capacity)
          );
          await this.fs.writeFileSync(
            this.path.join(this.dbPath, this.aforoFile),
            JSON.stringify(this.aforo)
          );
        }
      }
    },
    async socketAuthPetition(wsIpEmisor, ticket, time) {
      if (ticket && ticket != "\n" && ticket != "") {
        let { id } = this.getScanDevicesSockets().sockets.find(({ wsIp }) => {
          return wsIp == wsIpEmisor;
        });
        let ticketsList = ticket.split("\n");
        let newTicketList = [];
        let newQr = "";
        let access = "Access denied";
        let count = -1;
        for (let index = 0; index < ticketsList.length; index++) {
          if (
            ticketsList[index] != "" &&
            ticketsList[index] != " " &&
            ticketsList[index] != "\n"
          ) {
            let splitTicket = ticketsList[index].split(".");
            if (splitTicket[0] == "6") {
              let existDevice = await this.searchAccessNFCDeviceDB(
                splitTicket[1]
              );
              if (existDevice) {
                access = "Access granted-E";
                let authqr = `6.${existDevice}.${
                  splitTicket[1]
                }.11.${Date.now()}.11.0.1`;
                await this.addAuthDB(authqr + "." + id);
              }
            } else if (splitTicket.length == 2) {
              ///tipo 1
              if (splitTicket[0] != "") {
                //QR
                let existQr = await this.searchAccessKeyDB(splitTicket[1]);
                if (existQr) {
                  access = "Access granted-E";
                  let authqr = `${splitTicket.join(".")}.${Date.now()}.1.0.1`;
                  await this.addAuthDB(authqr + "." + id);
                }
              } else {
                //teclado
                let existPin = await this.searchAccessPinDB(splitTicket[1]);
                if (existPin) {
                  access = "Access granted-E";
                  let authPin = `.${existPin}.${Date.now()}.1.0.1`;
                  await this.addAuthDB(authPin + "." + id);
                }
              }
            } else if (splitTicket[0] == "3") {
              newQr = await this.removeQrDB(splitTicket.join("."));
              if (
                newQr &&
                this.aforo.current_capacity < this.aforo.max_capacity
              ) {
                count = newQr.split(".").slice(-1)[0];
                access = "Access granted-E";
                let authqr = `${splitTicket.join(
                  "."
                )}.${Date.now()}.1.0.1.${count}`;
                newTicketList.push(authqr);
                await this.addAuthDB(
                  authqr
                    .split(".")
                    .slice(0, -1)
                    .join(".") +
                    "." +
                    id
                );
                this.aforo.current_capacity++;
                this.aforo.ocupacion = parseInt(
                  100 * (this.aforo.current_capacity / this.aforo.max_capacity)
                );
                await this.fs.writeFileSync(
                  this.path.join(this.dbPath, this.aforoFile),
                  JSON.stringify(this.aforo)
                );
              }
            }
          }
        }
        try {
          this.getScanDevicesSockets().sockets.map(({ wsIp, socket }) => {
            if (wsIp != wsIpEmisor) {
              if (newTicketList.length > 0) {
                try {
                  socket.send(
                    `${JSON.stringify({
                      type: "delTickets",
                      status: "1",
                      size: newTicketList.length
                    })}////\n${newTicketList.join("\n")}`
                  );
                } catch (error) {}
              }
            } else {
              try {
                socket.send(
                  `${JSON.stringify({
                    type: "authTicket",
                    status: "1",
                    size: 1
                  })}////\n${access}.${count}`
                );
              } catch (error) {}
            }
          });
        } catch (error) {}
      }
    },
    async socketAuthorizedTickets(wsIpEmisor, tickets) {
      if (tickets && tickets != "\n" && tickets != "") {
        let { id } = this.getScanDevicesSockets().sockets.find(({ wsIp }) => {
          return wsIp == wsIpEmisor;
        });
        let ticketsList = tickets.split("\n");
        let newTicketList = [];
        for (let index = 0; index < ticketsList.length; index++) {
          if (
            ticketsList[index] != "" &&
            ticketsList[index] != " " &&
            ticketsList[index] != "\n"
          ) {
            let splitTicket = ticketsList[index].split(".");
            if (splitTicket.length == 6) {
              ///tipo 1
              if (splitTicket[0] == "6") {
                await this.addAuthDB(`${splitTicket.join(".")}.${id}`);
              } else if (splitTicket[0] != "") {
                //QR
                await this.addAuthDB(splitTicket.join(".") + "." + id);
              } else {
                //teclado
                let existPin = await this.searchAccessPinDB(splitTicket[1]);
                if (existPin) {
                  splitTicket[1] = existPin;
                  await this.addAuthDB(splitTicket.join(".") + "." + id);
                }
              }
            } else if (splitTicket[0] == "3") {
              if (splitTicket[0] == "3") {
                let newQr = await this.removeQrDB(splitTicket.join("."));
                if (newQr) {
                  let count = newQr.split(".").slice(-1)[0];
                  newTicketList.push(
                    `${splitTicket.slice(0, -1).join(".")}.${count}`
                  );
                }
                await this.addAuthDB(
                  `${splitTicket.slice(0, -1).join(".")}.${id}`
                );
              }
              if (this.aforo.current_capacity < this.aforo.max_capacity) {
                this.aforo.current_capacity++;
                this.aforo.ocupacion = parseInt(
                  100 * (this.aforo.current_capacity / this.aforo.max_capacity)
                );
                await this.fs.writeFileSync(
                  this.path.join(this.dbPath, this.aforoFile),
                  JSON.stringify(this.aforo)
                );
              }
            }
          }
        }
        if (newTicketList.length > 0) {
          try {
            this.getScanDevicesSockets().sockets.map(({ wsIp, socket }) => {
              if (wsIp != wsIpEmisor) {
                try {
                  socket.send(
                    `${JSON.stringify({
                      type: "delTickets",
                      status: "1",
                      size: newTicketList.length
                    })}////\n${newTicketList.join("\n")}`
                  );
                } catch (error) {}
              }
            });
          } catch (error) {}
        }
      }
    },
    socketNewTickets(tickets) {
      try {
        this.getScanDevicesSockets().sockets.map(({ socket }) => {
          try {
            socket.send(
              `${JSON.stringify({
                type: "newTickets",
                status: "1",
                size: tickets.split("\n").length
              })}////\n${tickets}\n`
            );
          } catch (error) {}
        });
      } catch (error) {}
    },
    createTicketsDates(date) {
      let addZeroStarter = str => {
        return str.length > 1 ? str : "0" + str;
      };
      let gmt = "+0";
      if (new Date().getUTCHours() < date.getHours()) {
        gmt = new Date().getHours() - new Date().getUTCHours() - 24;
      } else {
        gmt = new Date().getHours() - new Date().getUTCHours();
      }
      gmt = gmt < 0 ? "" + gmt : "+" + gmt;
      return `${addZeroStarter(date.getFullYear() + "")}-${addZeroStarter(
        date.getMonth() + 1 + ""
      )}-${addZeroStarter(date.getDate() + "")} ${addZeroStarter(
        date.getHours() + ""
      )}:${addZeroStarter(date.getMinutes() + "")} GMT ${gmt}`;
    }
  } /* closed methods */,
  beforeDestroy() {
    this.clearForm();
  },
  components: {
    GenerateQr
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/bookingOffice/BookingOffice.vue